var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "h-full" }, [
    _vm.showTable
      ? _c("div", { staticClass: "table component" }, [
          _c("div", { staticClass: "wrapper" }, [
            _c("table", [
              _vm.tableOptions.showHeader
                ? _c("thead", [
                    _c(
                      "tr",
                      [
                        _vm._l(_vm.localAttributes, function(a) {
                          return _c(
                            "th",
                            {
                              key: a.name,
                              class: [
                                _vm.getClassNames(a.classNames),
                                a.noSort ? "no-sort" : ""
                              ],
                              on: {
                                click: function($event) {
                                  return _vm.canSort(a)
                                }
                              }
                            },
                            [
                              _c("span", { class: "s" + a.sorted }, [
                                _vm._v(_vm._s(a.label))
                              ])
                            ]
                          )
                        }),
                        _vm.hasActions
                          ? _c("th", { staticClass: "action" }, [
                              _vm.hasHeadAction
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "head-action",
                                      on: {
                                        click: function($event) {
                                          return _vm.headAction()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.tableOptions.headAction) +
                                          " "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          : _vm._e()
                      ],
                      2
                    )
                  ])
                : _vm._e(),
              _c(
                "tbody",
                _vm._l(_vm.pagedItems, function(item) {
                  return _c(
                    "tr",
                    {
                      key: item.id,
                      on: {
                        dblclick: function($event) {
                          return _vm.editItem(item)
                        }
                      }
                    },
                    [
                      _vm._l(_vm.localAttributes, function(a) {
                        return _c(
                          "td",
                          {
                            key: a.name,
                            class: _vm.getClassNames(a.classNames)
                          },
                          [
                            a.type === "badge"
                              ? _c("span", [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "badge",
                                      class:
                                        a.config[_vm.getProperty(item, a.name)]
                                          .color
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            a.config[
                                              _vm.getProperty(item, a.name)
                                            ].text
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            a.type === "tick" &&
                            _vm.getProperty(item, a.name) !=
                              _vm.tableOptions.emptyText &&
                            _vm.getProperty(item, a.name)
                              ? _c("span", [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        width: "16",
                                        height: "12",
                                        viewBox: "0 0 16 12",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg"
                                      }
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d: "M1 7L5 11L15 1",
                                          stroke: "#10B981",
                                          "stroke-width": "2",
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round"
                                        }
                                      })
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            a.type === "image"
                              ? _c(
                                  "span",
                                  [
                                    _c("payment-icons", {
                                      attrs: {
                                        type: _vm.getProperty(item, a.name)
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            a.type === "currency"
                              ? _c("span", [
                                  _vm._v(
                                    " $" + _vm._s(_vm.getProperty(item, a.name))
                                  )
                                ])
                              : _vm._e(),
                            a.type === "text" || !a.type
                              ? _c("span", [
                                  _vm._v(
                                    " " + _vm._s(_vm.getProperty(item, a.name))
                                  )
                                ])
                              : _vm._e(),
                            a.type === "date"
                              ? _c("span", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("date")(
                                          _vm.getProperty(item, a.name),
                                          "dd-MM-yyyy"
                                        )
                                      )
                                  )
                                ])
                              : _vm._e()
                          ]
                        )
                      }),
                      _vm.hasActions
                        ? _c("td", { staticClass: "action" }, [
                            _vm.tableOptions.check
                              ? _c("div", { staticClass: "check" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          item[_vm.tableOptions.checkProperty],
                                        expression:
                                          "item[tableOptions.checkProperty]"
                                      }
                                    ],
                                    key: item.id + item.table_timestamps,
                                    attrs: {
                                      type: "checkbox",
                                      name: item.id + "-checked",
                                      id: item.id + "-checked",
                                      disabled: _vm.actionDisbled
                                    },
                                    domProps: {
                                      checked:
                                        item[_vm.tableOptions.checkProperty],
                                      checked: Array.isArray(
                                        item[_vm.tableOptions.checkProperty]
                                      )
                                        ? _vm._i(
                                            item[
                                              _vm.tableOptions.checkProperty
                                            ],
                                            null
                                          ) > -1
                                        : item[_vm.tableOptions.checkProperty]
                                    },
                                    on: {
                                      change: [
                                        function($event) {
                                          var $$a =
                                              item[
                                                _vm.tableOptions.checkProperty
                                              ],
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                _vm.$set(
                                                  item,
                                                  _vm.tableOptions
                                                    .checkProperty,
                                                  $$a.concat([$$v])
                                                )
                                            } else {
                                              $$i > -1 &&
                                                _vm.$set(
                                                  item,
                                                  _vm.tableOptions
                                                    .checkProperty,
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1))
                                                )
                                            }
                                          } else {
                                            _vm.$set(
                                              item,
                                              _vm.tableOptions.checkProperty,
                                              $$c
                                            )
                                          }
                                        },
                                        function($event) {
                                          return _vm.checkItem(item)
                                        }
                                      ]
                                    }
                                  })
                                ])
                              : _vm._e(),
                            _vm.tableOptions.edit
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "edit",
                                    on: {
                                      click: function($event) {
                                        return _vm.editItem(item)
                                      }
                                    }
                                  },
                                  [
                                    _vm.iconActions
                                      ? _c("span", [
                                          _c("i", {
                                            staticClass: "icn icn-pencil-alt sm"
                                          })
                                        ])
                                      : _vm._e(),
                                    !_vm.iconActions
                                      ? _c(
                                          "span",
                                          { staticClass: "action-label" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.tableOptions.editLabel)
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              : _vm._e(),
                            _vm.tableOptions.delete
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "delete",
                                    on: {
                                      click: function($event) {
                                        return _vm.deleteItem(item)
                                      }
                                    }
                                  },
                                  [
                                    _vm.iconActions
                                      ? _c("span", [
                                          _c("i", {
                                            staticClass: "icn icn-trash sm"
                                          })
                                        ])
                                      : _vm._e(),
                                    !_vm.iconActions
                                      ? _c(
                                          "span",
                                          { staticClass: "action-label" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.tableOptions.deleteLabel
                                              )
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              : _vm._e()
                          ])
                        : _vm._e()
                    ],
                    2
                  )
                }),
                0
              )
            ])
          ]),
          _vm.showPaginator
            ? _c("div", { staticClass: "paginator" }, [
                _vm.tableOptions.pages && _vm.tableOptions.pages.length > 1
                  ? _c("div", { staticClass: "size" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.itemsPerPage,
                              expression: "itemsPerPage"
                            }
                          ],
                          on: {
                            change: [
                              function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.itemsPerPage = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              },
                              function($event) {
                                return _vm.pageItems()
                              }
                            ]
                          }
                        },
                        _vm._l(_vm.tableOptions.pages, function(page) {
                          return _c(
                            "option",
                            { key: page, domProps: { value: page } },
                            [_vm._v(_vm._s(page))]
                          )
                        }),
                        0
                      )
                    ])
                  : _vm._e(),
                _vm.items
                  ? _c("div", { staticClass: "count" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.start + 1) +
                          "-" +
                          _vm._s(
                            _vm.end > _vm.items.length
                              ? _vm.items.length
                              : _vm.end
                          ) +
                          " of " +
                          _vm._s(_vm.items.length) +
                          " "
                      )
                    ])
                  : _vm._e(),
                _c("div", { staticClass: "nav" }, [
                  _c(
                    "div",
                    {
                      staticClass: "icon prev",
                      on: {
                        click: function($event) {
                          return _vm.prevPage()
                        }
                      }
                    },
                    [_c("i", { staticClass: "icn icn-chevron-left sm" })]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "icon",
                      on: {
                        click: function($event) {
                          return _vm.nextPage()
                        }
                      }
                    },
                    [_c("i", { staticClass: "icn icn-chevron-right sm" })]
                  )
                ])
              ])
            : _vm._e()
        ])
      : _vm._e(),
    _vm.showEmpty
      ? _c("div", { staticClass: "empty" }, [
          _c("div", { staticClass: "empty-content" }, [
            !_vm.tableOptions.discreet
              ? _c("img", {
                  attrs: {
                    src: require("@/assets/img/empty.png"),
                    alt: "empty"
                  }
                })
              : _vm._e(),
            !_vm.filtered
              ? _c("div", { staticClass: "title" }, [
                  _vm._v("No records to display")
                ])
              : _vm._e(),
            !_vm.filtered
              ? _c("div", { staticClass: "description" }, [
                  _vm._v("Looks like this table is empty.")
                ])
              : _vm._e(),
            _vm.filtered
              ? _c("div", { staticClass: "title" }, [
                  _vm._v("No result found for this search")
                ])
              : _vm._e(),
            _vm.filtered
              ? _c("div", { staticClass: "description" }, [
                  _vm._v(
                    "Sorry we couldn't find any results matching your search."
                  )
                ])
              : _vm._e()
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }